import store from 'store';

// Auth
const tokenKey = process.env.VUE_APP_TOKEN_KEY;
export const getAuthToken = () => store.get(tokenKey);
export const setAuthToken = (token) => {
  store.set(tokenKey, token);
};
export const removeAuthToken = () => store.remove(tokenKey);

const langKey = process.env.VUE_APP_LANG_KEY;
export const getAppLang = () => store.get(langKey);
export const setAppLang = (l) => store.set(langKey, l);
export const defaultLang = () => {
  const navLang = navigator.language || navigator.userLanguage;
  switch (navLang) {
    case 'tr':
    case 'tr-TR': return 'tr';
    case 'en':
    case 'en-US':
    case 'en-UK': return 'en';
    default: return 'tr';
  }
};

const selectedQuizKey = process.env.VUE_APP_SELECTED_QUIZ_KEY;
export const getSelectedQuiz = () => store.get(selectedQuizKey);

export const setSelectedQuiz = (quiz) => store.set(selectedQuizKey, quiz);

export const removeSelectedQuiz = () => store.remove(selectedQuizKey);
